export default "__VITE_ASSET__f$CVnU4p__"